<template>
  <div class="multi-file">
    <div class="file-item" v-for="(img, index) in fileUrls" :key="index">
      <span style="display: none">{{imgNum}}</span>
      <el-image
        :src="img"
        :fit="'cover'"
        :preview-src-list="previewImages"
        :ref="'img_' + index"
        v-if="
          img.split('.')[img.split('.').length - 1] == 'png' ||
          img.split('.')[img.split('.').length - 1] == 'jpg' ||
          img.split('.')[img.split('.').length - 1] == 'gif' ||
          img.split('.')[img.split('.').length - 1] == 'jpeg' ||
          img.split('.')[img.split('.').length - 1] == 'bmp'  ||
          img.split('.')[img.split('.').length - 1] == 'tif'
        "
      ></el-image>
      <a target="_blank" :href="img" v-else>
        <img
          src="../../assets/imgs/fj.png"
          alt=""
          style="height: 130px; width: 130px"
        />
      </a>
      <div class="file-list-actions" style="margin-top: 0px; top: 70%">
        <div
          v-if="
            img.split('.')[img.split('.').length - 1] == 'png' ||
            img.split('.')[img.split('.').length - 1] == 'jpg' ||
            img.split('.')[img.split('.').length - 1] == 'gif' ||
            img.split('.')[img.split('.').length - 1] == 'jpeg' ||
            img.split('.')[img.split('.').length - 1] == 'bmp' ||
            img.split('.')[img.split('.').length - 1] == 'tif'
          "
          class="action-item"
          @click="handlePreview(index)"
        >
          <i class="el-icon-zoom-in"></i>
        </div>
        <div
          v-if="!disabled"
          class="action-item"
          @click="deleteFile(index)"
        >
          <i class="el-icon-delete"></i>
        </div>
      </div>
    </div>
    <div v-if="!disabled && imgNum < maxImgNum" class="input-div">
      <div class="up-btn-center">
        <div class="btn-plus">+</div>
        <div style="font-size: 16px; margin-top: -15px">添加</div>
      </div>
      <input
        type="file"
        ref="upInput"
        @change="flieChange"
        style="width: 126px; height: 126px"
      />
    </div>
    <span v-else-if="disabled && fileUrls.length === 0">
        没有上传任何附件
    </span>
  </div>
</template>

<script>
import { post } from "@/api/common/index";
export default {
  name: "MultiUploader",
  props: ["disabled"],
  data() {
    return {
        fileUrls:[],  // 文件的Url（数组）
        fileNames:[], // 文件名（多个用,分隔）
        imgNum: 0,    // 文件数量
        maxImgNum: 5, // 最大可上传数量
        previewImages: [],
        fileInfo: {
            fileName: "",
            fileContent: "",
            fileBase64Content: "",
        },
        imgDataList: [],
        imgData: "",
        
    };
  },
  watch:{
    fileUrls() {
        this.imgNum = this.fileUrls.length
    }
  },
  methods: {
    // 控件初始化
    // 参数：
    // filenames：文件名（多个用,分隔）
    // fileUrls： 文件Url（数组）
    // maxImgNum： 最大可上传数量
    init(fileNames, fileUrls, maxImgNum) {
      if(fileNames){
        this.fileUrls = fileUrls;
        this.fileNames = fileNames.split(",");
        this.imgNum = this.fileNames.length;
      }
      else{
        this.fileUrls = [];
        this.fileNames = [];
        this.imgNum = 0;
      }

      this.maxImgNum = (maxImgNum == null || maxImgNum == undefined) ? 5 : maxImgNum;
    },
    // 父组件保存时，从该组件得到已上传的文件名（多个用,分隔）
    getFiles() {
      return this.fileNames.join(",");
    },
    // 图片Url地址（多个用,分隔）
    getFileUrls(){
      return this.fileUrls;
    },
    // 新建上传
    flieChange() {
      this.readAsDataURL();
    },
    // 查看图片
    handlePreview(index) {
      this.previewImages = this.fileUrls
        .slice(index)
        .concat(this.fileUrls.slice(0, index));
      this.$refs["img_" + index][0].clickHandler.call();
    },
    // 上传图片
    readAsDataURL() {
      var reader = new FileReader();
      var that = this;
      var file = this.$refs.upInput.files[0];
      
      if (file) {
        var fileType = file.name.substring(file.name.lastIndexOf(".") + 1);
        if(fileType.toLowerCase() == "gif"){
          this.$refs.upInput.value = ""
          this.$message.error('图片只能是JPG、PNG或BMP格式!');
          return;
        }
        
        // 将文件以Data URL形式读入页面
        that.imgUrlBase64 = reader.readAsDataURL(file);
        that.fileInfo.fileName = file.name;
        reader.onload = function () {
            //console.log(e)
            var base64Content = this.result.split(",")[1];
            that.fileInfo.fileBase64Content = base64Content;

            // 大小超过1M，则开启图片压缩（其它文件格式不压缩）
            if (file.size > 1024 * 1024) {
                that.imageCompress(this.result,file.name).then(function(data){
                    that.fileInfo.fileBase64Content = data.split(',')[1];
                    that.uploadFile(that.fileInfo);
                })
            }
            else{
                that.uploadFile(that.fileInfo);
            }            

            that.imgBase = this.result;
            that.imgDataList.push(that.imgBase);            
        };
      }
    },
    // 调用接口保存
    uploadFile(fileInfo){
        var that = this;
        post("/api/common/upload_file", fileInfo).then((res) => {
            //console.log(res);
            that.fileNames.push(res.data.fileName);
            if (that.fileUrls === undefined) {
                that.fileUrls = Array(0);
            }
            that.fileUrls.push(res.data.url);
        });
    },
    // 删除附件
    deleteFile(index) {
      this.fileUrls.splice(index, 1);
      this.fileNames.splice(index, 1);
    },
    // 图片压缩
    imageCompress(base64, fileName) {
        var fileType = fileName.substring(fileName.lastIndexOf(".") + 1);
        const isJpg = fileType === "jpg";
        const isBmp = fileType === "bmp";
        const isPng = fileType === "png";
        const isJpeg = fileType === "jpeg";

        // 非图片类型文件，直接返回Base64字符串
        if(!isJpg&&!isJpeg&&!isPng&&!isBmp)
        {
            return new Promise(function(resolve){
                resolve(base64);
            })
        }

        let Img = new Image(), dataURL = ''
        Img.src = base64
        let p = new Promise(function (resolve) {
            Img.onload = function () { //要先确保图片完整获取到，这是个异步事件
                let canvas = document.createElement("canvas"), //创建canvas元素
                    width = Img.width, //确保canvas的尺寸和图片一样
                    height = Img.height
                // 默认将长宽设置为图片的原始长宽，这样在长宽不超过最大长度时就不需要再处理
                let ratio = width / height,
                    maxLength = 1500,
                    newHeight = height,
                    newWidth = width
                // 在长宽超过最大长度时，按图片长宽比例等比缩小
                if (width > maxLength || height > maxLength) {
                    if (width > height) {
                        newWidth = maxLength
                        newHeight = maxLength / ratio
                    } else {
                        newWidth = maxLength * ratio
                        newHeight = maxLength
                    }
                }
                canvas.width = newWidth
                canvas.height = newHeight
                canvas.getContext("2d").drawImage(Img, 0, 0, newWidth, newHeight) //将图片绘制到canvas中
                dataURL = canvas.toDataURL('image/jpeg', 0.8) //转换图片为dataURL
                resolve(dataURL)
            }
        })

        return p
    },  
  },
};
</script>

<style scoped>
.multi-file{position: relative}
.multi-file .file-item{width: 132px;height: 132px;position: relative;margin:0 15px 5px 0;display: inline-block}
.multi-file .file-item .delete-btn{position: absolute;right: 2px;top:2px; display: none;font-size: 20px;cursor: pointer;border-radius: 50%;height: 32px;width: 32px;
  background-color: rgba(99,99,99,0.5);color: white;line-height: 32px;text-align: center}
.multi-file .file-item:hover .delete-btn{display: block;z-index: 1}
.multi-file .el-image{width: 132px;height: 132px}
.multi-file .input-div{position: relative; display: inline-block;width: 132px;height: 132px; border: 1px dashed #e4e4e4;;box-sizing: border-box}
.multi-file .up-btn-center{color: #d3d3d3; top: 25%;position: absolute;width: 100%;text-align: center}
.multi-file .btn-plus{font-size: 30px}
.multi-file .input-div input{position: absolute;top:0;bottom: 0;width: 100%;opacity: 0}
.multi-file .file-item .file-list-actions{position: absolute;top:50%;height: 40px;margin-top: -20px;width: 100%;background-color: rgba(96,96,96,0.4);text-align: center;display: none}
.multi-file .file-item:hover .file-list-actions{display: block}
.file-list-actions .action-item{display: inline-block; text-align: center;padding: 5px;color: white;font-size: 22px; cursor: pointer}
</style>
